import React, { Component, useRef } from "react";
import { Map, TileLayer, Popup, Marker, withLeaflet, LayersControl } from "react-leaflet";
import Paper from '@material-ui/core/Paper';
import {MdMyLocation} from "react-icons/md";
import {
    InputAdornment, IconButton, Input
} from '@material-ui/core';
const MyMarker = props => {

    const initMarker = ref => {
        if (ref) {
            ref.leafletElement.openPopup()
        }
    }

    return <Marker ref={initMarker} {...props} />
}

class MapaWidget extends Component {
    constructor(props) {
        super(props);
        this.state = !this.props.selected.lat ? { currentPos: null } : { currentPos: this.props.selected };
        this.handleClick = this.handleClick.bind(this);
        this.mapaRef = React.createRef('map');
        this.centrar = () => {
            this.mapaRef.current.leafletElement.flyTo(this.props.selected, 15)
        }
    }


    handleClick(e) {

        this.props.select(e.latlng)
        this.setState({ currentPos: e.latlng });
    }
    
    render() {
        return (
            <Paper style={{ height: "100%", width: "100%", borderRadius: "15px", position: "relative" }}>
                <div
                    style={{
                        border: "2px solid rgba(0,0,0,0.2)",
                        borderRadius: "4px",
                        position: "absolute",
                        bottom: "10%",
                        right: "5%",
                        zIndex: "999",
                        backgroundColor: "white",
                        padding: "0px",
                    }}
                >
                    <IconButton
                        style={{ padding: "4px", color: "#414141" }}
                        onClick={() => { this.centrar() }}
                    >
                        <MdMyLocation />

                    </IconButton>
                </div>
                {this.props.open ?
                    <Map
                        style={{ height: "100%", width: "100%", borderRadius: "15px" }}
                        center={!this.props.selected.lat ? this.props.center : this.props.selected}
                        zoom={this.props.zoom}
                        ref={this.mapaRef}
                    >
                        <LayersControl>
                            <LayersControl.BaseLayer name="Satelital" checked>
                                <TileLayer
                                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" // satelital
                                />
                            </LayersControl.BaseLayer>
                            <LayersControl.BaseLayer name="Base" >
                                <TileLayer
                                    url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" //base
                                />
                            </LayersControl.BaseLayer>

                        </LayersControl>
                        {this.state.currentPos &&
                            <MyMarker position={!this.props.selected.lat ? this.state.currentPos : this.props.selected}>
                                <Popup>
                                    <p>Lat: {this.props.selected.lat}</p>
                                    <p>Lng: {this.props.selected.lng}</p>
                                </Popup>
                            </MyMarker>}

                    </Map> : <></>}
            </Paper>
        )
    }
}

export default MapaWidget;